/* eslint-disable no-lonely-if */
import React, { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import routerLoader from '../../i18n/router';
import SinTarjetaOro from './SinTarjetaOro';
import TarjetaOroDatos from './TarjetaOroDatos';
import { TarjetaService } from '../../services';
import { StorageHelper } from '../../utils/StorageHelper';
import { CryptoUtil } from '../../utils/CryptoUtil';
import { useAuthStore } from '../../store/AuthContext';
import NotFound from '../NotFound';
import { GtmConstants } from '../../utils/GtmConstants';
import useDatalayerEvents from '../../hooks/useDatalayerEvents';
import { CookieHelper } from '../../utils/CookieHelper';
import BotonVolverFlotante from '../../components/BotonVolverFlotante';
import DataService from '../../services/MisDatosService';
import {
  AccessData,
  PersonalData,
  PrefijoPais,
} from '../../types/PersonalData';
import useAPIError from '../../hooks/useAPIError';
import AccesData from '../MisDatos/AccessData';
import { useAppStore } from '../../store/AppContext';
import { FrontMappings } from '../../utils/FrontMappings';
import { MisDatosConstants } from '../../utils/MisDatosConstants';

const TarjetasOro: FC = () => {
  const dataUser = useAuthStore();
  const [tipoUsuarioTarjeta, setTipoUsuarioTarjeta] = useState<number>(-1);
  const [load, setLoad] = useState<boolean>(false);
  const [origenData, setOrigenData] = useState<string>('');
  const [showDataAccess, setShowDataAccess] = useState<boolean>(false);
  const [prefijosPaises, setPrefijosPaises] = useState<PrefijoPais[]>([]);
  const [accessData, setAccessData] = useState<AccessData>({
    dobleVerificacion: false,
    emailAcceso: '',
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [personalData, setPersonalData] = useState<PersonalData>({
    nombreCompleto: '',
    fechaNacimiento: '',
    idDocumento: '',
    tipoDocumento: -1,
    genero: '',
    prefijoTelefono: '-1',
    telefono: '',
    prefijoTelefonoSecundario: '-1',
    telefonoSecundario: '',
    emailContacto: '',
    idiomaComunicacion: '',
    nombre: '',
    apellido1: '',
    apellido2: '',
    tipoUsuario: -1,
    tipoSocioConsumidor: -1,
    tipoCambioMail: '',
    razonSocial: '',
    dniEditable: false,
    fromApp: '',
  });

  const TIPOTARJETA_TITULAR_Y_ORO = 4;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const TIPOTARJETA_NO_ORO = 0;
  const { promiseInProgress } = usePromiseTracker();
  const { t } = useTranslation();
  const { addError } = useAPIError();
  const dataApp = useAppStore();
  // eslint-disable-next-line @typescript-eslint/no-empty-function

  const setNotShowData = () => {
    return false;
  };

  const retrieveTipoUsuarioTarjeta = () => {
    if (StorageHelper.isTipoTarjetaUsuarioOroInSession()) {
      const tipoSession = CryptoUtil.decrypt(
        sessionStorage.getItem('tipoUsuarioTarjetaOro') as string,
      );
      setTipoUsuarioTarjeta(Number(tipoSession));
    } else {
      TarjetaService.getTipoUsuarioTarjetaOro().then((response) => {
        if (response.data.error !== true) {
          if (tipoUsuarioTarjeta < 0) {
            setTipoUsuarioTarjeta(response.data);
            sessionStorage.setItem(
              'tipoUsuarioTarjetaOro',
              CryptoUtil.encrypt(response.data.toString()),
            );
          } else {
            sessionStorage.setItem(
              'tipoUsuarioTarjetaOro',
              CryptoUtil.encrypt(response.data.toString()),
            );
          }
        }
      });
    }
  };

  const retrieveDataAcessoData = () => {
    DataService.accessData({}).then((response) => {
      const { data } = response;
      if (data && data.pojo) {
        setAccessData({
          emailAcceso: CryptoUtil.decryptAes(data.pojo.emailAcceso),
          dobleVerificacion: data.pojo.dobleVerificacion,
        });
      }
    });
  };

  const retrievePrefijosPais = () => {
    DataService.prefijoPais()
      .then((response) => {
        if (response.data.error === true) {
          console.log('Error');
        } else if (typeof response.data.pojos !== 'undefined') {
          setPrefijosPaises(response.data.pojos);
          setLoad(true);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const handleErrorV2PUpdate = (data: boolean) => {
    if (data) {
      sessionStorage.setItem('oro-error', 'true');
      window.location.href = routerLoader.LoadRouterByPath(
        FrontMappings.MISDATOS,
        dataApp.lang,
      );
    }
  };

  const getPersonalData = () => {
    DataService.personalData()
      .then((response) => {
        if (response.data.error === true) {
          console.log('Error');
        } else if (response.data && response.data.pojo) {
          response.data.pojo.idDocumento = CryptoUtil.decryptAes(
            response.data.pojo.idDocumento,
          );
          response.data.pojo.tipoDocumento = CryptoUtil.decryptAes(
            response.data.pojo.tipoDocumento,
          );
          response.data.pojo.nombre = CryptoUtil.decryptAes(
            response.data.pojo.nombre,
          );
          response.data.pojo.apellido1 = CryptoUtil.decryptAes(
            response.data.pojo.apellido1,
          );
          response.data.pojo.apellido2 = CryptoUtil.decryptAes(
            response.data.pojo.apellido2,
          );
          response.data.pojo.prefijoTelefono = CryptoUtil.decryptAes(
            response.data.pojo.prefijoTelefono,
          );
          response.data.pojo.telefono = CryptoUtil.decryptAes(
            response.data.pojo.telefono,
          );
          response.data.pojo.prefijoTelefonoSecundario = CryptoUtil.decryptAes(
            response.data.pojo.prefijoTelefonoSecundario,
          );
          response.data.pojo.telefonoSecundario = CryptoUtil.decryptAes(
            response.data.pojo.telefonoSecundario,
          );
          response.data.pojo.emailContacto = CryptoUtil.decryptAes(
            response.data.pojo.emailContacto,
          );

          if (
            response.data.pojo.tipoUsuario ===
            MisDatosConstants.ID_TIPO_USUARIO_PARTICULAR
          ) {
            response.data.pojo.fechaNacimiento = CryptoUtil.decryptAes(
              response.data.pojo.fechaNacimiento,
            );
            response.data.pojo.genero = CryptoUtil.decryptAes(
              response.data.pojo.genero,
            );
          } else if (
            response.data.pojo.tipoUsuario ===
            MisDatosConstants.ID_TIPO_USUARIO_EMPRESA
          ) {
            response.data.pojo.razonSocial = CryptoUtil.decryptAes(
              response.data.pojo.razonSocial,
            );
            response.data.pojo.cif = CryptoUtil.decryptAes(
              response.data.pojo.cif,
            );
          }
          setPersonalData(response.data.pojo);
        }
      })
      .catch(() => {
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  useEffect(() => {
    if (tipoUsuarioTarjeta < 0) {
      retrieveTipoUsuarioTarjeta();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoUsuarioTarjeta]);

  useEffect(() => {
    if (dataUser.user.token !== '' && tipoUsuarioTarjeta < 0) {
      retrieveTipoUsuarioTarjeta();
      retrievePrefijosPais();
    } else if (dataUser.user.token !== '') {
      if (tipoUsuarioTarjeta === TIPOTARJETA_TITULAR_Y_ORO) {
        setOrigenData('oro');
      }
      setShowDataAccess(false);
      retrieveDataAcessoData();
      retrievePrefijosPais();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token]);

  useEffect(() => {
    // eslint-disable-next-line no-prototype-builtins
    if (tipoUsuarioTarjeta > -1 && dataUser.user.hasOwnProperty('isEmpresa')) {
      setLoad(true);
    }
  }, [dataUser, tipoUsuarioTarjeta]);

  useDatalayerEvents(GtmConstants.MI_CUENTA);

  return (
    <div>
      <BotonVolverFlotante />
      {(() => {
        if (load) {
          if (CookieHelper.isBloqueada()) {
            return (
              <div>
                <NotFound />
              </div>
            );
          }
          if (
            (dataUser.user.isEmpresa &&
              tipoUsuarioTarjeta !== TIPOTARJETA_TITULAR_Y_ORO) ||
            dataUser.user.isGibraltar
          ) {
            return (
              <div>
                <NotFound />
              </div>
            );
          }
          if (tipoUsuarioTarjeta === TIPOTARJETA_NO_ORO) {
            return (
              <div>
                <SinTarjetaOro />
              </div>
            );
          }
          if (tipoUsuarioTarjeta === TIPOTARJETA_TITULAR_Y_ORO) {
            return (
              <div>
                <TarjetaOroDatos />
              </div>
            );
          }
        }
        return <></>;
      })()}
      <AccesData
        setUserForm={setNotShowData}
        setPassForm={setNotShowData}
        emailAcceso={accessData.emailAcceso}
        dobleVerificacion={accessData.dobleVerificacion}
        showAccessData={showDataAccess}
        load={load}
        promiseApi={promiseInProgress}
        cargarPersonalData={getPersonalData}
        cargarData={retrieveDataAcessoData}
        prefijosPaises={prefijosPaises}
        setShowPersonalData={setNotShowData}
        handlerErrorUpdate={handleErrorV2PUpdate}
        origenData={origenData}
      />
    </div>
  );
};
export default TarjetasOro;
